import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=4af3b218&scoped=true&"
import script from "./Teachers.vue?vue&type=script&lang=js&"
export * from "./Teachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af3b218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af3b218')) {
      api.createRecord('4af3b218', component.options)
    } else {
      api.reload('4af3b218', component.options)
    }
    module.hot.accept("./Teachers.vue?vue&type=template&id=4af3b218&scoped=true&", function () {
      api.rerender('4af3b218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/teachers/Teachers.vue"
export default component.exports